export default "__VITE_ASSET__CCZjA1ys__"